import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Melbourne Water – Hobsons Bay Main Upgrade Project</h3>
      </div>
      <div className="popup-content-source">
        <p>
          Melbourne Water will be completing works at their Port Melbourne site to connect in the new sewer main being built for the Hobsons Bay Main Upgrade Project. Visit Melbourne Water’s project page {' '}
          <a
            href="https://www.melbournewater.com.au/services/projects/hobsons-bay-main-upgrade-project"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map – Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MORE INFO: Melbourne Water – Hobsons Bay Main Upgrade Project',
              });
            }}
          >
            here
          </a>{' '}
          for more information.
        </p>
        <p>
          South East Water’s Sewer Mining Pump Station, once constructed, will connect to Melbourne Water’s asset to extract the city’s wastewater to the Water Recycling Plant, where it will be treated to class A Recycled Water.
        </p>
      </div>
    </>
  );
};

export default Content;
